import React from 'react';
import { Link, useNavigate } from 'react-router';

import AccountSwitcher from '@/features/accounts/components/AccountSwitcher';
import { useAuthToken } from '@repo/hooks/useAuthToken';
import { Dropdown, DropdownItem } from '@repo/ui/Dropdown';
import { SidebarTrigger } from '@repo/ui/Sidebar';

import { useAccount } from '@/hooks/useAccount';

import logoLight from '../../../assets/logos/logo-light.svg';
import logoDark from '../../../assets/logos/logo-dark.svg';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';

const Navbar = () => {
  const setToken = useAuthToken()[1];
  const user = useUser();
  const currentAccount = useAccount();
  const currentAccountId = currentAccount?.id;
  const navigate = useNavigate();

  const AccountNavItems: (DropdownItem | null)[] = [
    {
      label: 'Manage Account',
      onClick: () => navigate(`/a/${currentAccountId}/account-settings`),
    },

    POLICIES['account_allowed_access_ips:index'](user)
      ? {
          label: 'Security',
          onClick: () => navigate(`/a/${currentAccountId}/account-settings/ip-whitelist`),
        }
      : null,
  ];

  const UserNavItems: DropdownItem[] = [
    {
      label: 'User Settings',
      onClick: () => navigate(`/a/${currentAccountId}/user-settings/profile`),
    },
    {
      label: 'Sign Out',
      onClick: () => {
        localStorage.setItem('mercury_skip_redirect', 'true');
        setToken(null);
      },
    },
  ];

  return (
    <div className="flex fixed top-0 z-50 items-center w-full h-20 border-b bg-grey-200 dark:bg-blue-1000 border-grey-400 dark:border-grey-700">
      <div className={`hidden px-5 duration-300 md:block`}>
        <Link to={`/a/${currentAccountId}`} className="dark:text-blue-100">
          <img
            src={logoLight}
            alt="Swift SMS Gateway"
            width={140}
            height={75}
            className="block w-full dark:hidden max-w-[150px]"
          />
          <img
            src={logoDark}
            alt="Swift SMS Gateway"
            width={140}
            height={75}
            className="hidden w-full dark:block max-w-[150px]"
          />
        </Link>
      </div>

      <div className="px-2 sm:px-5 md:px-12">
        <AccountSwitcher />
      </div>

      <div className="hidden gap-10 items-center pr-10 ml-auto md:flex">
        <Dropdown label="Account" items={AccountNavItems} align="end" />
        <Dropdown label="User" items={UserNavItems} align="end" />
      </div>

      <SidebarTrigger
        variant="secondary"
        className="md:hidden! ml-auto mr-4 size-9 [&>svg]:size-6!"
      />
    </div>
  );
};

export default Navbar;
